// React for Website

import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
//outsource
import { Row, Col, Typography, Divider } from "antd";

//components
import VoucherControl from "./component/voucher_control";
import VoucherListing from "./component/voucher_listing";

//redux
import { useDispatch, useSelector } from "react-redux";
import {
  snapAllVoucherPackage,
  unSnapVoucherPackage,
} from "../../store/voucher/voucher.action";
import { snapBranchs, unSnapBranchs } from "../../store/branch/branch.action";
import { voucherPackageSelector } from "../../store/voucher/voucher.selector";
import { ownerSelector } from "../../store/role/role.selector";
import { branchsSelector } from "../../store/branch/branch.selector";

//styles
import "./style.css";

const { Title } = Typography;

const BranchVoucher = () => {
  // -------------------------- VAR --------------------------
  const params = useParams();
  const branchId = params.id;
  // -------------------------- STATE --------------------------
  const [data, setData] = useState(null);
  const [search, setSearch] = useState("");
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const voucherPackages = useSelector(voucherPackageSelector);
  const branches = useSelector(branchsSelector);
  // const ownerId = owner?.id || "";
  console.log("branches", branches);
  // -------------------------- FUNCTION --------------------------

  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    if (branchId) {
      dispatch(snapAllVoucherPackage({ branchId }));
      dispatch(snapBranchs());
    }

    return () => {
      dispatch(unSnapVoucherPackage());
      dispatch(unSnapBranchs());
    };
  }, [dispatch, branchId]);

  useEffect(() => {
    if (voucherPackages) {
      setData(voucherPackages);
    }
  }, [voucherPackages]);

  //search
  useEffect(() => {
    let data = voucherPackages || [];
    if (search !== "") {
      data = data?.filter((item) => {
        const label = `${item?.name} | ${item?.shopId} | ${item?.packageId}`;
        const valids = label?.toLowerCase().includes(search.toLowerCase());
        return valids;
      });
    }

    setData(data);
  }, [search]);

  // -------------------------- RENDER --------------------------
  const renderBody = () => {
    return (
      <Row>
        <Col xl={24} lg={24} md={24} xs={24}>
          <VoucherControl data={data} setSearch={setSearch} />
        </Col>
        <Divider />
        <Col xl={24} lg={24} md={24} xs={24}>
          <VoucherListing branches={branches} data={data} />
        </Col>
      </Row>
    );
  };

  // -------------------------- MAIN --------------------------
  return (
    <Row>
      <Col xl={24} lg={24} md={24} xs={24}>
        {renderBody()}
      </Col>
    </Row>
  );
};

export default BranchVoucher;
